/** Tiny DOM helpers — no framework, the UI is a handful of screens. */

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  ...children: (Node | string)[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === "class") node.className = v;
    else if (k === "text") node.textContent = v;
    else node.setAttribute(k, v);
  }
  node.append(...children);
  return node;
}

export const uiRoot = (): HTMLElement => document.getElementById("ui")!;

export function showScreen(screen: HTMLElement): void {
  // any full-screen menu means we're NOT in a locked-pointer gameplay view —
  // always release pointer lock so the mouse cursor comes back (fixes the
  // "lost cursor after a match/practice" bug even if a game forgot to).
  if (document.pointerLockElement) document.exitPointerLock();
  const root = uiRoot();
  root.replaceChildren(screen);
}
